const AlertMsg = ({
  msg,
  type = 'alert-info'
}) => `<div class="${type} animate-pulse rounded-md p-4 my-2">
         <p class="text-sm font-medium">${msg}</p>
       </div>`

export default AlertMsg
